var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4123 9.99996L20.7123 1.71246C20.8717 1.51817 20.9532 1.2715 20.9409 1.02045C20.9286 0.769398 20.8233 0.531907 20.6456 0.354172C20.4678 0.176438 20.2303 0.0711671 19.9793 0.058837C19.7282 0.046507 19.4816 0.127999 19.2873 0.287462L10.9998 8.58746L2.71227 0.287462C2.51797 0.127999 2.27131 0.046507 2.02025 0.058837C1.7692 0.0711671 1.53171 0.176438 1.35398 0.354172C1.17624 0.531907 1.07097 0.769398 1.05864 1.02045C1.04631 1.2715 1.1278 1.51817 1.28727 1.71246L9.58727 9.99996L1.28727 18.2875C1.09948 18.4771 0.994141 18.7331 0.994141 19C0.994141 19.2668 1.09948 19.5229 1.28727 19.7125C1.47841 19.8973 1.73388 20.0006 1.99977 20.0006C2.26565 20.0006 2.52113 19.8973 2.71227 19.7125L10.9998 11.4125L19.2873 19.7125C19.4784 19.8973 19.7339 20.0006 19.9998 20.0006C20.2656 20.0006 20.5211 19.8973 20.7123 19.7125C20.9 19.5229 21.0054 19.2668 21.0054 19C21.0054 18.7331 20.9 18.4771 20.7123 18.2875L12.4123 9.99996Z",
    fill: "#B9CCD5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bdb083fe5a11ff2ae622f68d5ac8e3a0.svg";
export { ForwardRef as ReactComponent };